module.exports = __webpack_public_path__ + "static/media/product_gpa.732257f3.svg";